import Vue from 'vue'
import Router from 'vue-router'
import AuthLayout from '@/layouts/Auth'
import AppLayout from '@/layouts/App'
import store from '@/store'

Vue.use(Router)

const router = new Router({
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      redirect: 'dashboard',
      component: AppLayout,
      meta: { authRequired: true, hidden: true },
      children: [

        // Dashboard
        {
          path: '/dashboard',
          meta: {
            title: 'Dashboard',
          },
          component: () => import('./views/dashboard/analytics'),
        },

        // Sliders
        {
          path: '/sliders',
          meta: {
            title: 'Sliders',
          },
          component: () => import('./views/sliders'),
        },

        // Sliders
        {
          path: '/static-banner',
          meta: {
            title: 'Banner Estático',
          },
          component: () => import('./views/static-banner'),
        },

        {
          path: '/advertising',
          meta: {
            title: 'Publicidad',
          },
          component: () => import('./views/advertising'),
        },

        {
          path: '/images-menu',
          meta: {
            title: 'Imagenes Menú',
          },
          component: () => import('./views/images-menu'),
        },

        {
          path: '/multimedia',
          meta: {
            title: 'Multimedia',
          },
          component: () => import('./views/multimedia'),
        },

        {
          path: '/profiles',
          meta: {
            title: 'Perfiles',
          },
          component: () => import('./views/profiles'),
        },

        {
          path: '/new-services',
          meta: {
            title: 'Nuevos Servicios',
          },
          component: () => import('./views/new-services'),
        },

        {
          path: '/braze',
          meta: {
            title: 'Braze',
          },
          component: () => import('./views/braze'),
        },

        {
          path: '/privacy',
          meta: {
            title: 'Privacidad',
          },
          component: () => import('./views/privacy'),
        },
        // UI Kits
        {
          path: '/ui-kits/bootstrap',
          meta: {
            title: 'Bootstrap',
          },
          component: () => import('./views/ui-kits/bootstrap'),
        },
        {
          path: '/ui-kits/antd',
          meta: {
            title: 'Ant Design',
          },
          component: () => import('./views/ui-kits/antd'),
        },
         // Terms and conditions
         {
          path: '/terms',
          meta: {
            title: 'Términos y Condiciones',
          },
          component: () => import('./views/terms-edit'),
        },
        // 404
        {
          path: '/404',
          meta: {
            title: 'Error 404',
          },
          component: () => import('./views/system/404'),
        },
      ],
    },

    // System Pages
    {
      path: '/system',
      component: AuthLayout,
      redirect: '/system/login',
      children: [
        {
          path: '/system/login',
          meta: {
            title: 'Login',
          },
          component: () => import('./views/system/login'),
        },
        {
          path: '/system/forgot-password',
          meta: {
            title: 'Forgot Password',
          },
          component: () => import('./views/system/forgot-password'),
        },
        {
          path: '/system/register',
          meta: {
            title: 'Register',
          },
          component: () => import('./views/system/register'),
        },
        {
          path: '/system/lockscreen',
          meta: {
            title: 'Lockscreen',
          },
          component: () => import('./views/system/lockscreen'),
        },
        {
          path: '/system/404',
          meta: {
            title: 'Error 404',
          },
          component: () => import('./views/system/404'),
        },
        {
          path: '/system/500',
          meta: {
            title: 'Error 500',
          },
          component: () => import('./views/system/500'),
        },
      ],
    },

    // Redirect to 404
    {
      path: '*', redirect: 'system/404', hidden: true,
    },
  ],
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.authRequired)) {
    if (!store.state.user.user) {
      next({
        path: '/system/login',
        query: { redirect: to.fullPath },
      })
    } else {
      next()
    }
  } else {
    next()
  }
})

export default router
